import { clientApi } from 'shared/api/clientApi.ts'
import {
  UmrahListResponse,
  UmrahTour,
  UmrahTourParams,
} from 'shared/api/umrah/tours/model.ts'
import { Pagination, Response } from 'shared/models/general.ts'

export const UmrahListApi = {
  getUmrahList(params: Pagination, abort?: AbortSignal) {
    return clientApi.get<UmrahListResponse>(`umra-tours/list`, {
      params: params,
      signal: abort,
    })
  },

  getUmrahTour(tourId: string, params: UmrahTourParams) {
    return clientApi.get<Response<UmrahTour>>(`umra-tours/details/${tourId}`, {
      params: params,
    })
  },
}
